import { Injectable, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicFormField } from '../form/formulary';

@Injectable({ providedIn: 'root' })
export class FormBuilderService {
  private fb = inject(FormBuilder);

  //TODO: cambiar el any por el tipado real
  buildForm(fields: DynamicFormField[], initialValues?: Record<string, unknown>): FormGroup {
    const controls: Record<string, FormControl> = {};

    for (const field of fields) {
      const validators = field.validators || (field.required ? [Validators.required] : []);
      let initialValue = '';
      if (initialValues && field.key in initialValues) {
        initialValue = initialValues[field.key] as string;
      }
      controls[field.key] = new FormControl(initialValue, validators);
    }
    return this.fb.group(controls);
  }
}
